


































import {Component, Vue} from "vue-property-decorator";
import {FundProjectYearSummaryDto} from "@/api/appService";
import api from "@/api";
import ExportWord from "@/components/DownloadWord/index.vue";

@Component({
  name: "fundProjectYearSummaryDetail",
  components: {
    ExportWord,
  },
  filters: {
    formatType(type?: string) {
      switch (type) {
        case "ProjectAssessmentPlan":
          return "评估计划通知模板";

        case "OrganizationInvestigation":
          return "尽职调查通知模板";
      }
    },
  },
})
export default class FundProjectYearSummaryDetail extends Vue {
  detail: FundProjectYearSummaryDto = {};
  typeList: any = [];
  styles = "";
  selector = "table-detail-world";
  filename = "年度总结表";

  created() {
    if (this.$route.params.id) {
      this.fetchEnumType();
      this.fetchDetail();
    }
  }

  async fetchEnumType() {
    await api.enumService
      .getValues({
        typeName: "NotifyTemplateType",
      })
      .then((res) => {
        this.typeList = res;
      });
  }

  // 获取详情
  async fetchDetail() {
    api.fundProjectYearSummaryService
      .get({id: Number(this.$route.params.id)})
      .then((res) => {
        this.detail = {...res};
      });
  }

  // 返回
  private cancel() {
    this.$router.back();
  }
}
